module.exports = __webpack_public_path__ + "static/media/finance-feature-tile-icon-01.c1ce0a2e.svg";